import React from 'react';
import { useSelector } from 'react-redux';

import { CMSReferences } from '@swf/cms';
import { select } from '@swf/core/store';

const EmbeddedFooter: React.FC = () => (
  <CMSReferences references={useSelector(select.cms.getWebsite)?.site_footer} />
);

export default EmbeddedFooter;
